import React from 'react';
import styles from './estudio_em_movimento.module.scss';
import InstagramIcon from '../../icons/instagramIcon.tsx';
import FacebookIcon from '../../icons/facebookIcon.tsx';
import SiteIcon from '../../icons/siteIcon.tsx';

const WHATSAPP_NUMBER = '5517997563971';
const WHATSAPP_MSG = 'Olá! Vim pelo cartão digital e gostaria de saber mais...';
const INSTAGRAM_URL = 'https://www.instagram.com/estudio_em_movimento?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==';
const FACEBOOK_URL = 'https://www.facebook.com/alvesrolinha/';
const SITE_URL = 'http://estudioemovimento.com.br/';

const whatsappLink = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MSG)}`;

const Estudio_em_movimento: React.FC = () => {
    return (
        <div className={styles.estudio_em_movimento}>
            <div className={styles.page}>
                <div className={styles.hero}>
                    <img
                        src={require('./src/background-links.png')}
                        alt="Gustavo Alves - Personal trainer"
                        className={styles.heroImage}
                    />
                </div>

                <div className={styles.content}>
                    <div className={styles.statsRow}>
                        <div className={styles.statBlock}>
                            <span className={styles.statValue}>+100</span>
                            <span className={styles.statLabel}>Clientes</span>
                        </div>
                        <div className={styles.statBlock}>
                            <span className={styles.statValue}>3</span>
                            <span className={styles.statLabel}>Anos de experiência</span>
                        </div>
                    </div>
                    <div className={styles.socialRow}>
                        <a
                            href={INSTAGRAM_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.socialLink}
                            aria-label="Instagram"
                        >
                            <InstagramIcon height="28" color="#50a3d2" />
                        </a>
                        <a
                            href={FACEBOOK_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.socialLink}
                            aria-label="Facebook"
                        >
                            <FacebookIcon height="28" color="#50a3d2" />
                        </a>
                        <a
                            href={SITE_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.socialLink}
                            aria-label="Site"
                        >
                            <SiteIcon height="28" width="28" color="#50a3d2" />
                        </a>
                    </div>

                    <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className={styles.bannerLink}>
                        <img src={require('./src/banner-1.png')} alt="Musculação personalizada - Toque para saber mais" className={styles.banner} />
                    </a>
                    <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className={styles.bannerLink}>
                        <img src={require('./src/banner-2.png')} alt="Massagem - Toque para saber mais" className={styles.banner} />
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Estudio_em_movimento;
